export default __webpack_public_path__ + "static/media/facebook.0e68aaf5.svg";